import React, { useContext } from 'react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import SearchByParty from '@Components/Search/SearchByParty'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'

const PublicSearchByWriterTab = () => {
    const { publicSearchWritersStore } = useContext(StoresContext)

    return (
        <SearchByParty
            searchPartyStore={publicSearchWritersStore}
            partyQueryStore={publicSearchWritersStore}
            partyDetailsCardComponent={SearchResultPartyDetailsCard}
            syncSearchTermsToUrl
        />
    )
}

export default observer(PublicSearchByWriterTab)
